import _ from 'lodash';
import moment from 'moment-timezone';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTimeRange } from '@/core/DateTimeRange.molecule';
import { sqWorksheetStore } from '@/core/core.stores';
import { useFlux } from '@/core/hooks/useFlux.hook';
import { isValidCapsule } from '@/tools/manualCondition/conditionFormula.service';
import type { RangeField } from '@/core/DateTimeRange.molecule';
import type { Capsule } from '@/utilities/datetime.constants';

interface CapsuleInputIF {
  setCapsuleInputValidStatus?: (isValid: boolean) => void;
  onChange?: (capsuleWindow: Capsule) => void;
  trackInformation?: string;
  trackAction: string;
  trackCategory: string;
  dateFormat?: string;
  capsuleWindow?: Capsule;
  autoUpdateDate?: boolean;
}

export const CapsuleInput = (props: CapsuleInputIF) => {
  const {
    setCapsuleInputValidStatus,
    capsuleWindow = {
      startTime: moment().subtract(1, 'hour').valueOf(),
      endTime: moment().valueOf(),
      properties: [],
    },
    onChange,
    trackInformation,
    trackAction,
    trackCategory,
    dateFormat,
    autoUpdateDate = true,
  } = props;

  const { timezone } = useFlux(sqWorksheetStore);

  const { t } = useTranslation();

  useEffect(() => {
    setCapsuleWindowStatus(isValidCapsule(capsuleWindow));
  }, []);

  const setCapsuleWindow = (capsuleWindow: RangeField<moment.Moment>) => {
    const capsule = {
      ...capsuleWindow,
      startTime: capsuleWindow.start.valueOf(),
      endTime: capsuleWindow.end.valueOf(),
    };
    _.isFunction(onChange) && onChange(capsule);
    setCapsuleWindowStatus(isValidCapsule(capsule));
  };

  const setCapsuleWindowStatus = (isValid: boolean) => {
    _.isFunction(setCapsuleInputValidStatus) && setCapsuleInputValidStatus(isValid);
  };

  return (
    <div className="flexRowContainer">
      <div className="flexColumnContainer tw:mb-sq-5 tw:justify-around">
        <span className="tw:font-bold">{t('CAPSULE_INPUT_DATE_TIME_LABEL')}</span>
        <span className="tw:font-bold">{t('CAPSULE_INPUT_DATE_TIME_LABEL')}</span>
      </div>
      <div className="flexColumnContainer text-center tw:items-center tw:justify-center">
        <DateTimeRange
          autoUpdateDate={autoUpdateDate}
          startTime={moment(capsuleWindow.startTime)}
          endTime={moment(capsuleWindow.endTime)}
          onChange={setCapsuleWindow}
          dateFormat={dateFormat}
          timezone={timezone}
          hideTimezone={true}
          trackCategory={trackCategory}
          trackAction={trackAction}
          trackInformation={{
            start: `Start. ${trackInformation}`,
            end: `End. ${trackInformation}`,
          }}
        />
      </div>
      {capsuleWindow && !isValidCapsule(capsuleWindow) && (
        <p className="sq-text-danger text-center">{t('FORM.START_BEFORE_END')}</p>
      )}
    </div>
  );
};
